import { Dropdown, OptionType } from "@fanduel/og-fe-library";
import { Dispatch, SetStateAction } from "react";
import styles from "./termList.module.scss";

interface TermListFiltersProps {
  changeHandler: (newFilterIndex: number) => void;
  selected: number;
  setSelected: Dispatch<SetStateAction<number>>;
}
interface DesktopFiltersProps {
  changeHandler: (newFilterIndex: number) => void;
  selected: number;
}

const filterChoices: OptionType[] = [
  { label: "All Terms" },
  { label: "Wagering" },
  { label: "Race Conditions" },
  { label: "During the Race" },
  { label: "Horses and Horse Care" },
  { label: "Jockeys" },
];

const DesktopFilters = ({ changeHandler, selected }: DesktopFiltersProps) => (
  <ul className={styles.desktopFilters}>
    {filterChoices.map((filter, index) => (
      <li
        className={selected === index ? styles.selected : ""}
        key={filter.label}
      >
        <button
          onClick={() => {
            changeHandler(index);
          }}
          type="button"
        >
          {filter.label}
        </button>
      </li>
    ))}
  </ul>
);

const MobileFilters = ({
  changeHandler,
  selected,
  setSelected,
}: TermListFiltersProps) => (
  <div className={styles.mobileFilters}>
    <Dropdown
      onChange={changeHandler}
      variant="outlined"
      title="Filter"
      options={filterChoices}
      selected={selected}
      setSelected={setSelected}
    />
  </div>
);

const TermListFilters = (props: TermListFiltersProps) => (
  <>
    <MobileFilters {...props} />
    <DesktopFilters {...props} />
  </>
);

export default TermListFilters;
